import { AppThunk } from 'redux/store';
import { TypesSettingsApplication } from './type';
import {
  setStorageAmountApplication,
  setStorageTermApplication,
  setStoragePromoCodeApplication,
  setStorageLoanPurpose,
} from 'utils';

export const setSettingApplicationAmount =
  (amount: number): AppThunk<void> =>
  (dispatch) => {
    setStorageAmountApplication(amount);
    dispatch({ type: TypesSettingsApplication.SET_SETTINGS_APPLICATION_AMOUNT, data: amount });
  };

export const setSettingApplicationTerm =
  (term: number): AppThunk<void> =>
  (dispatch) => {
    setStorageTermApplication(term);
    dispatch({ type: TypesSettingsApplication.SET_SETTINGS_APPLICATION_TERM, data: term });
  };
export const setSettingApplicationPromocode =
  (promo_code: string): AppThunk<void> =>
  (dispatch) => {
    setStoragePromoCodeApplication(promo_code);
    dispatch({
      type: TypesSettingsApplication.SET_SETTINGS_APPLICATION_PROMOCODE,
      data: promo_code,
    });
  };
export const setSettingLoanPurpose =
  (loan_purpose: string): AppThunk<void> =>
  (dispatch) => {
    setStorageLoanPurpose(loan_purpose);
    dispatch({
      type: TypesSettingsApplication.SET_SETTINGS_APPLICATION_LOAN_PURPOSE,
      data: loan_purpose,
    });
  };
